import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What styles do you specialize in?',
  answer: 'We specialize in all braid styles including knotless braids, box braids, cornrows, goddess braids, bohemian braids, feed-ins, Senegalese twists, and faux locs.'
}, {
  question: 'How do I book an appointment?',
  answer: "You can book an appointment by sending us a DM on Instagram (@roziiepse) or calling us at (240) 921-7857. We'll check availability and secure your slot."
}, {
  question: 'Is the deposit refundable?',
  answer: 'No, we require a $25 non-refundable deposit to secure your appointment slot. This goes towards your total service cost.'
}, {
  question: 'How long does it take?',
  answer: "Service duration varies depending on the style, length, and size of the braids. Most styles take between 4 to 8 hours. We'll provide an estimated time when you book."
}, {
  question: 'Do I need to bring my own hair?',
  answer: "Please inquire when booking! For some styles hair is included, while for others you may need to bring specific hair packs. We'll let you know exactly what's needed."
}, {
  question: 'Where are you located?',
  answer: 'We are located at 7375 Executive Place, Suite 214, Lanham, MD. There is ample parking available.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 md:py-32 bg-warm-brown text-cream" data-id="element-120">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-122">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mb-6" data-id="element-123">
            Common Questions
          </h2>
          <div className="w-16 h-px bg-brand-gold mx-auto" data-id="element-124"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-125">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border-b border-cream/10 overflow-hidden" data-id="element-126">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" data-id="element-127">
                <span className="font-display text-xl md:text-2xl group-hover:text-brand-gold transition-colors" data-id="element-128">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-brand-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-129" />
              </button>
              <AnimatePresence data-id="element-130">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-131">
                    <p className="pb-6 text-cream/70 font-body leading-relaxed" data-id="element-132">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}